export const GetWindDiagnosticTable = "GetWindDiagnosticTable";
export const GetWindDiagnosticTableSuccess = "GetWindDiagnosticTableSuccess";
export const GetWindDiagnosticTableError = "GetWindDiagnosticTableError";
export const OpenDiagnosticChartDialog = "OpenDiagnosticChartDialog";
export const CloseDiagnosticChartDialog = "CloseDiagnosticChartDialog";
export const OpenRollingBearingDiagnosticChartDialog = "OpenRollingBearingDiagnosticChartDialog";
export const CloseRollingBearingDiagnosticChartDialog = "CloseRollingBearingDiagnosticChartDialog";
export const OpenHSSMisalagmentDiagnosticChartDialog = "OpenHSSMisalagmentDiagnosticChartDialog";
export const CloseHSSMisalagmentDiagnosticChartDialog = "CloseHSSMisalagmentDiagnosticChartDialog";
export const OpenBrokenPinionStage2DiagnosticChartDialog = "OpenBrokenPinionStage2DiagnosticChartDialog";
export const CloseBrokenPinionStage2DiagnosticChartDialog = "CloseBrokenPinionStage2DiagnosticChartDialog";
export const OPEN_LOOSENESS_DIAGNOSTIC_DIALOG = "OPEN_LOOSENESS_DIAGNOSTIC_DIALOG";
export const CLOSE_LOOSENESS_DIAGNOSTIC_DIALOG = "CLOSE_LOOSENESS_DIAGNOSTIC_DIALOG";
export const OPEN_PLANETARY_DIAGNOSTIC_DIALOG = "OPEN_PLANETARY_DIAGNOSTIC_DIALOG";
export const CLOSE_PLANETARY_DIAGNOSTIC_DIALOG = "CLOSE_PLANETARY_DIAGNOSTIC_DIALOG";
export const OPEN_MAIN_SHAFT_UNBALANCE_DIALOG = "OPEN_MAIN_SHAFT_UNBALANCE_DIALOG";
export const CLOSE_MAIN_SHAFT_UNBALANCE_DIALOG = "CLOSE_MAIN_SHAFT_UNBALANCE_DIALOG";
export const OPEN_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG = "OPEN_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG";
export const CLOSE_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG = "CLOSE_MAIN_SHAFT_ANGULAR_MISALIGNMENT_DIALOG";
export const OPEN_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG = "OPEN_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG";
export const CLOSE_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG = "CLOSE_MAIN_SHAFT_PARALLEL_MISALIGNMENT_DIALOG";
export const OPEN_ELECTRIC_FAIL_DIALOG = "OPEN_ELECTRIC_FAIL_DIALOG";
export const CLOSE_ELECTRIC_FAIL_DIALOG = "CLOSE_ELECTRIC_FAIL_DIALOG";

export const OPEN_GEN_SHAFT_UNBALANCE_DIALOG = "OPEN_GEN_SHAFT_UNBALANCE_DIALOG";
export const CLOSE_GEN_SHAFT_UNBALANCE_DIALOG = "CLOSE_GEN_SHAFT_UNBALANCE_DIALOG";
